import { render, staticRenderFns } from "./WorksBulkEditingDialog.vue?vue&type=template&id=2f570313"
import script from "./WorksBulkEditingDialog.vue?vue&type=script&lang=js"
export * from "./WorksBulkEditingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports